import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['sliderFrom', 'sliderTo', 'slider']

  static values = {
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 100
    },
    step: {
      type: Number,
      default: 1
    },
  }

  initialize() {
    let controller = this;

    $(controller.sliderTarget).ionRangeSlider({
      type: "double",
      min: controller.minValue,
      max: controller.maxValue,
      step: controller.setpValue,
      from: $(controller.sliderFromTarget).val(),
      to: $(controller.sliderToTarget).val(),
      onChange: controller.updateInputs.bind(controller)
    });
  }

  updateInputs(data) {
    $(this.sliderFromTarget).val(data.from);
    $(this.sliderToTarget).val(data.to);
  }
}
